// src/components/map/MapController.jsx
import { useEffect } from 'react'
import { useMap } from 'react-leaflet'

const MapController = ({ center, zoom }) => {
  const map = useMap()
  useEffect(() => {
    if (center && zoom) map.setView(center, zoom)
  }, [map, center, zoom])
  return null
}

export default MapController
